import Pochta from "./Pochta";
function ISTJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper" >
     <img src="/img/ISTJ Администратор.png" className="ISTJ"/>
     </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
        <h2>ISTJ</h2>
       <p><strong>Процент населения:</strong> 11–14%</p>
<p><strong>Среди мужчин:</strong> 14–18%</p>
<p><strong>Среди женщин:</strong> 8–10%</p>
<p><strong>Стратегия:</strong> Постоянное совершенствование</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ISTJ черпают энергию в одиночестве и тишине. 
  Им нужно время, чтобы обдумать информацию и принять решение. 
  Они восстанавливают силы в спокойной обстановке, вдали от шумных компаний.
</p>
<p>
  Решения ISTJ принимают на основе фактов и логики. 
  Они не доверяют интуиции и эмоциям — им нужны доказательства и практическая польза. 
  Они ценят порядок, структуру и чёткие инструкции.
</p>
<p>
  Это ответственные и дисциплинированные люди. 
  Они всегда доводят дела до конца, даже если это скучно или сложно. 
  Им трудно адаптироваться к переменам, но они — надёжная опора в любом деле.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ISTJ — это каменная стена. Эмоции для них — неэффективны. Они не умеют выражать чувства, 
  и их лицо никогда не выдаёт того, что происходит внутри. Им трудно идти на компромисс, 
  и они могут казаться упрямыми и холодными. Их перфекционизм часто пугает.
</p>

<p>
  ISTJ — это человек, на которого можно положиться в самой трудной ситуации. Если они сказали «я сделаю» — 
  это сделано, даже если ради этого пришлось бы переплыть океан. Они — невидимые герои, 
  которые держат мир в порядке. Их можно не замечать, но без них всё рухнет.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ISTJ;